import '../../tables/Table.module.css'
import '../../css_styles/button_styles.css'
import PagePrev from '../../tables/PagePrev'
import PageNext from '../../tables/PageNext'
import classes from '../../tables/Table.module.css'
import { useState, useEffect } from 'react';


function CSVInfoTable(props) {

    const [numRows, setNumRows] = useState(0)
    const [tableRows, setTableRows] = useState([])
    const [showPageNav, setShowPageNav ] = useState(false);
    const [nextActive, setNextActive] = useState(false);
    const [prevActive, setPrevActive] = useState(false);
    const [tableEmpty, setTableEmpty ] = useState(true);
    const [showMin, setShowMin] = useState(0);
    const [showMax, setShowMax] = useState(0);
    const [idSlice, setIdSlice] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); //set litemsPerPage = 10 as default
    const [campaignIdKey, setCampaignIdKey] = useState('')

    const columnWidths = ['130px', '70px', '220px', '220px', '400px', '230px', '250px']; 

    useEffect(() => {
        setNumRows(props.tableRows.length)
        setIdSlice(1);
        setShowPageNav(false);
        setNextActive(false);
        setPrevActive(false);
        setTableEmpty(true);
        if (props.campaign_id !== undefined){
            setCampaignIdKey(`_${props.campaign_id}`)
        }
        if (props.tableRows.length > 0){
            setTableEmpty(false)
            setShowMin(1);
            if(props.itemsPerPage !== undefined && props.itemsPerPage !== null) 
            {
             setShowMax(Math.min(props.itemsPerPage, props.tableRows.length));
            }
            else {
            setShowMax(Math.min(props.itemsPerPage, props.tableRows.length));
            }
        }
        if (props.tableRows.length > props.itemsPerPage)
        {
            setShowPageNav(true)
            setNextActive(true);
        }        
        if(props.itemsPerPage !== undefined && props.itemsPerPage !== null) 
        {
             setItemsPerPage(props.itemsPerPage); 
        }

    }, [props.tableRows.length, props.itemsPerPage, props.campaign_id]);

    useEffect(() => {
        setTableRows(props.tableRows)
    }, [props.tableRows]);



    let tableHead = (
        <>
            <tr >
                {props.colNames.map((columnName, index) => (<th 
                            key={`colname_${index}`}
                            style={{ width: columnWidths[index], minWidth: columnWidths[index], maxWidth: columnWidths[index]}}> 
                                {columnName}</th>))}
            </tr>
        </>);

        
    let tableBody = tableRows.slice(showMin-1, showMax).map((row, rowIndex) => {
        return (
            <tr key={`row_${rowIndex}`} >
                {Object.keys(row).map((key) => {
                    if (key === 'selected') {
                        return (
                            <td key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`}>
                                <input 
                                    style={{ transform: 'scale(0.9)'}}
                                    id={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`} 
                                    onChange={props.onSelect} 
                                    type='checkbox' 
                                    checked={row[key]} 
                                />
                            </td>
                        );
                    } 

                    else if (key === 'uuid'){
                        return (
                            <td 
                              className={classes.paginated} 
                              style={{verticalAlign: 'top'}} 
                              key={`${key}$_${rowIndex + (idSlice - 1) * itemsPerPage}`}>
                              {
                                    <button id={`download_${row[key]}`} 
                                            className={'downloadLinkTable'}
                                            style={{textAlign: 'left'}}
                                            onClick={props.downloadCSVData}>
                                        {row[key]}
                                    </button>
                              }
                            </td>
                          );

                    }
                    else if (key === 'factors'){
                        return (
                            <>
                            <style>
                            {`
                                .greenBullets li {
                                color: black;  /* Text color */
                                list-style-type: square;
                                padding-left: 0px;
                                margin-left: -20px;
                                }

                                .greenBullets li::marker {
                                color: var(--aixelo-green);  /* Bullet color */
                                }
                            `}
                            </style>
                            <td 
                              className={classes.paginated} 
                              style={{verticalAlign: 'top'}} 
                              key={`${key}$_${rowIndex + (idSlice - 1) * itemsPerPage}`}>
                              <ul className="greenBullets" style={{marginTop:'0px', marginLeft:'0px', marginBottom: '0px'}}>
                                {
                                  row[key].map((item, index) => (
                                    <li key={index}>{item}</li>  // Renders each array item as a bullet point
                                  ))
                                }
                              </ul>
                            </td>
                            </>
                          );
                    }

                    else if (key === 'measurements'){
                        return (
                            <>
                            <style>
                            {`
                                .greenBullets li {
                                color: black;  /* Text color */
                                list-style-type: square;
                                padding-left: 0px;
                                margin-left: -20px;
                                }

                                .greenBullets li::marker {
                                color: var(--aixelo-green);  /* Bullet color */
                                }
                            `}
                            </style>
                            <td 
                              className={classes.paginated} 
                              style={{verticalAlign: 'top'}} 
                              key={`${key}_${rowIndex + (idSlice - 1) * itemsPerPage}`}>
                              <ul className="greenBullets" style={{marginTop:'0px', marginLeft:'0px', marginBottom: '0px'}}>
                                {
                                  row[key].map((item, index) => (
                                    <li key={index}>{item}</li>  // Renders each array item as a bullet point
                                  ))
                                }
                              </ul>
                            </td>
                            </>
                          );
                    }
                    
                    else if (key === 'raw_data'){
                        return (
                            <td 
                              className={classes.paginated} 
                              style={{verticalAlign: 'top'}} 
                              key={`${key}$_${rowIndex + (idSlice - 1) * itemsPerPage}`}>
                              {
                                row[key].map((item, index) => (
                                    <button id={`download_${item.uuid}_${rowIndex+(idSlice-1)*itemsPerPage}_${index}${campaignIdKey}`} 
                                            className={'downloadLinkTable'} 
                                            style={{textAlign: 'left'}}
                                            onClick={props.downloadRawDataFile}>
                                        {item.filename}
                                    </button>
                                ))
                              }
                            </td>
                          );

                    }


                    else if (key === 'training_data'){
                        return (
                            <td 
                              className={classes.paginated} 
                              style={{verticalAlign: 'top'}} 
                              key={`${key}$_${rowIndex + (idSlice - 1) * itemsPerPage}`}>
                              {
                                row[key].map((item, index) => (
                                    <button id={`download_${item}_${rowIndex+(idSlice-1)*itemsPerPage}_${index}${campaignIdKey}`} 
                                            className={'downloadLinkTable'}
                                            style={{textAlign: 'left'}}
                                            onClick={props.downloadTrainingDataFile}>
                                        {item}
                                    </button>
                                ))
                              }
                            </td>
                          );

                    }


                    else if (key === 'data_origin'){
                        if(row[key]['origin'] === 'CampaignCycleMeasurement'){
                            let uuid_experimental_setup = row[key]['campaign_setup']['uuid_experimental_setup']
                            let uuid_design_space = row[key]['campaign_setup']['uuid_design_space']
                            let uuid_objective = row[key]['campaign_setup']['uuid_objective']
                            return(
                                <td className={classes.paginated} 
                                    style={{verticalAlign: 'top'}} 
                                    key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`}>
                                        {/* <div>data upload:</div> */}
                                        <div>campaign uuid: {row[key]['uuid_opt_campaign']}</div>
                                        <div style={{marginTop:'5px'}}>cycle id: {row[key]['cycle_idx']+1}</div>
                                        <button id={`download_${rowIndex+(idSlice-1)*itemsPerPage}_${uuid_experimental_setup}_${uuid_design_space}_${uuid_objective}${campaignIdKey}`} 
                                            className={'downloadLink'}
                                            style={{textAlign: 'left', marginTop:'5px'}}
                                            onClick={props.viewCampaignSetup}>
                                        campaign setup
                                    </button>
                                </td>);
                        }
                        else {
                            return(
                                <td className={classes.paginated} key={`${key}${'origin'}_${rowIndex+(idSlice-1)*itemsPerPage}`}>
                                    <div>{row[key]['origin']}</div>
                                    <div style={{marginTop:'5px', color:'red'}}>Todo Implement Show Information </div>
                            </td>);
                        }
                    }

                    else {
                        if (row[key] === '') { 
                            return (
                                <td className={classes.paginated} 
                                    key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`}
                                    style={{verticalAlign: 'top'}} >
                                    &nbsp;
                                </td>);
                        }
                        else {
                            return (
                                <td className={classes.paginated} 
                                    style={{verticalAlign: 'top'}} 
                                    key={`${key}_${rowIndex+(idSlice-1)*itemsPerPage}`}>
                                    {row[key]}
                                </td>);
                        }
                    }
                })}
            </tr>
        );
    });


    function handlePagePrev() {
        let new_count = idSlice - 1;
        setShowMin((new_count - 1)*itemsPerPage +1 )
        if( (new_count - 1)*itemsPerPage +1 === 1 ) { setPrevActive(false);}
        setShowMax((new_count)*itemsPerPage )
        setNextActive(true);
        setIdSlice(new_count);
    }


    function handlePageNext() {
        let new_count = idSlice + 1;
        let old_count = idSlice;
        setShowMin((old_count)*itemsPerPage +1 )
        if( (showMax + itemsPerPage) >= numRows ) 
        {
            setNextActive(false);
            setShowMax(numRows);
        }
        else {
            setShowMax((new_count)*itemsPerPage )
        } 
        setPrevActive(true);
        setIdSlice(new_count);
    }


    let show_min_max=(<>{showMin}-{showMax} of {numRows}</>);
    if(showMin === showMax){ show_min_max=(<>{showMin} of {numRows}</>); }

    let pageNav = (<></>);
    if (!tableEmpty) {
        pageNav = (<>
            <div className={classes.page_nav} style={{position:'relative', height:'20px', width: '100%'}}>
                <div style={{paddingRight:'20px', paddingBottom:'4px', }}>{show_min_max} </div>
            </div>
        </>);
    }
    if (!tableEmpty && showPageNav) {
        pageNav = (<>
            <div className={classes.page_nav} style={{position:'relative', height:'15px', width: '100%'}}>
                <PagePrev handleClick={handlePagePrev} active={prevActive}/>   
                <PageNext handleClick={handlePageNext} active={nextActive}/>
                <div style={{paddingBottom:'4px', paddingLeft:'10px'}}>{show_min_max} </div>
            </div>
        </>);
    }


    let actionPanel = (<></>);
    if (props.actionsOnSelect !== undefined && props.actionsOnSelect !== null) {
        actionPanel = props.actionsOnSelect.map((action, index) => (
                <button className={'tableButton'} key={`action_${index}`} onClick={action.action}>
                    {action.title}
                </button>
        ));
    }


    return(<>
        {pageNav}
        <div style={{display:'flex', gap: '0px', padding:'0px', margin:'0px'}}>
            {actionPanel}
        </div>
        <table key={campaignIdKey} className={classes.paginated} style={{tableLayout:'fixed', width: 'fit-content'}}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={props.colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableBody}
            </tbody>
        </table>
    </>
    );

}



export default CSVInfoTable;